import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import "./popup.scss";
import Button from "../button/button";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import {useTranslation} from "react-i18next";
import React, {ReactElement} from "react";
import { Utils } from "../../../../helpers/utils";

interface PopupProps {
    open: boolean;
    changeOpenProp?: () => void;
    className?: string;
    header?: string | JSX.Element;
    secondHeader?: string;
    icon?: JSX.Element;
    content: JSX.Element;
    cancel?: (() => void) | null;
    action?: (() => void) | null;
    actionText?: string;
    cancelText?: string;
    testId: string;
    httpError?: ReactElement;
    isWaiting?: boolean;
    otherBtn?: JSX.Element;
    hideCancelButton?: boolean;
    disabledButton?: boolean;
}

export function Popup(props: PopupProps) {
    const {t} = useTranslation();

    if (props.open) {
        return (
            <Dialog
                className={`popup ${props.className} ${Utils.isTabletOrMobile() ? "mobile" : ""}`}
                open={props.open}
                onClose={props.changeOpenProp}
                fullWidth={true}
                data-testid={props.testId}
            >
                {props.httpError}

                <DialogTitle className="header">
                    <div className="header-text">{props.header}</div>
                    <div className="close-icon" onClick={() => props.cancel ? props.cancel() : null}>
                        <CloseIcon/>
                    </div>
                </DialogTitle>

                <div className="icon">
                    <div>{props.icon}</div>
                </div>

                <div className="second-header">{props.secondHeader}</div>

                <DialogContent className="content">
                    {props.content}
                </DialogContent>

                <DialogActions className="actions">
                    <div className="buttons">
                        {!props.hideCancelButton && props.cancel && (
                            <Button
                                type="secondary"
                                onClick={props.cancel}
                                testId={`${props.testId}-cancelBtn`}
                                text={props.cancelText ?? t("cancel")}
                            />
                        )}
                        {props.otherBtn}
                        {props.action && (
                            <Button
                                type="primary"
                                onClick={props.action}
                                testId={`${props.testId}-actionBtn`}
                                text={props.actionText ?? t("save")}
                                isWaiting={props.isWaiting}
                                disabled={props.disabledButton}
                            />
                        )}
                    </div>
                </DialogActions>
            </Dialog>
        );
    } else {
        return <></>;
    }
}
